import Highcharts from 'highcharts';

import {Asset} from '@deviceinsight/ng-ui-api-client';

import {SingleValueChartData} from '../common/types';

type PieSeriesData = {
	name: string;
	id: string;
	color: string;
	y: number | null | undefined;
};

type PieSeries = {
	name: string;
	colorByPoint: boolean;
	data: Array<PieSeriesData>;
};

const createSeriesData = (
	chartDataItem: SingleValueChartData,
	seriesIndex: number,
	showAssetNames: boolean,
	assets: Asset[]
): PieSeriesData => {
	const {label, kpiName, color, value, uuid, assetUrn} = chartDataItem;
	const seriesName =
		label || (showAssetNames ? `${assets.find(({urn}) => assetUrn === urn)?.name || '--'} - ${kpiName}` : kpiName);
	return {
		name: seriesName,
		id: uuid ? uuid : seriesName,
		color,
		y: value || null
	};
};

// chart options
const buildChartOptions = (series: PieSeries, unit: string): any => {
	return {
		chart: {
			type: 'pie'
		},
		title: {
			text: null
		},
		credits: {
			enabled: false
		},
		plotOptions: {
			pie: {
				allowPointSelect: true,
				cursor: 'pointer',
				dataLabels: {
					enabled: true,
					format: `<b>{point.name}</b><br/>{point.y} ${unit || ''}<br/>{point.percentage:.1f} %`
				}
			}
		},
		series: [series],
		tooltip: {
			// @ts-ignore
			formatter: function () {
				// @ts-ignore
				return `${this.point.name}: ${this.point.y} ${unit || ''} ${this.point.percentage.toFixed()} %`;
			}
		},
		accessibility: {
			enabled: false
		}
	};
};

const chartValuesDataToPieSeriesData = (
	chartDataSets: SingleValueChartData[],
	showAssetNames: boolean,
	assets: Asset[]
): PieSeriesData[] =>
	chartDataSets.map((chartData, index) => createSeriesData(chartData, index, showAssetNames, assets));

export const updateChart = (
	chart: Highcharts.Chart,
	chartDataSets: SingleValueChartData[],
	showAssetNames: boolean,
	assets: Asset[]
) => {
	if (chart && chart.series) {
		chartValuesDataToPieSeriesData(chartDataSets, showAssetNames, assets).forEach(({y, name, id}) => {
			const dataToUpdate = chart.series[0].data.find(({name: existingName, id: idInChart}: any) =>
				idInChart && id ? idInChart === id : name === existingName
			);

			if (dataToUpdate) {
				dataToUpdate.update(
					{
						y
					},
					false
				);
			}
		});
		chart.redraw();
	}
};
export const createChart = (
	domNode: any,
	chartDataSets: SingleValueChartData[],
	unit: string,
	showAssetNames: boolean,
	assets: Asset[]
): any =>
	Highcharts.chart(
		domNode,
		buildChartOptions(
			{
				name: 'piechart',
				colorByPoint: true,
				data: chartValuesDataToPieSeriesData(chartDataSets, showAssetNames, assets)
			},
			unit
		)
	);
